type RuntimeConfig = {
  REACT_APP_NAME?: string;
  REACT_APP_DESC?: string;
  REACT_APP_VERSION?: string;
  REACT_APP_CLIENTID?: string;
  REACT_APP_AUTHORITY?: string;
  REACT_APP_REDIRECT_URI?: string;
  REACT_APP_API_BASE_URI?: string;
  REACT_APP_API_URI?: string;
  REACT_APP_RESOURCE_URI?: string;
  REACT_APP_RESOURCE_SCOPE?: string;
  REACT_APP_RESOURCE_SCOPE_EXTERNALGATEWAY?: string;
  REACT_APP_RESOURCE_SCOPE_ERPDATAGATEWAY?: string;
};

const runtimeConfig =
  (
    globalThis as typeof globalThis & {
      __RUNTIME_CONFIG__?: RuntimeConfig;
    }
  ).__RUNTIME_CONFIG__ || {};

// Unreplaced pipeline tokens (e.g. "#{authority}#") mean no runtime value: fall back to .env.
const isUnreplacedToken = (value?: string) => !value || /^#\{.*\}#$/.test(value);

const getConfigValue = (key: keyof RuntimeConfig) => {
  const runtimeValue = runtimeConfig[key];
  return isUnreplacedToken(runtimeValue) ? process.env[key] : runtimeValue;
};

export const appName = getConfigValue("REACT_APP_NAME");
export const appDesc = getConfigValue("REACT_APP_DESC");
export const version = getConfigValue("REACT_APP_VERSION");
export const port = process.env.PORT;
export const nodeEnv = process.env.NODE_ENV;
export const clientId = getConfigValue("REACT_APP_CLIENTID");
export const authority = getConfigValue("REACT_APP_AUTHORITY");
export const redirectUri = getConfigValue("REACT_APP_REDIRECT_URI");

const apiBaseUri =
  getConfigValue("REACT_APP_API_BASE_URI") ||
  getConfigValue("REACT_APP_RESOURCE_URI") ||
  "";

const normalizedApiBaseUri = apiBaseUri.endsWith("/")
  ? apiBaseUri
  : `${apiBaseUri}/`;

export const centralGatewayUri = normalizedApiBaseUri;
export const centralGatewayAPIUri =
  getConfigValue("REACT_APP_API_URI") || `${normalizedApiBaseUri}api/`;
export const scopeCentralGateway =
  getConfigValue("REACT_APP_RESOURCE_SCOPE") ||
  getConfigValue("REACT_APP_RESOURCE_URI");
export const scopeExternalGateway = getConfigValue(
  "REACT_APP_RESOURCE_SCOPE_EXTERNALGATEWAY",
);
export const scopeERPDataGateway = getConfigValue(
  "REACT_APP_RESOURCE_SCOPE_ERPDATAGATEWAY",
);
